import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

const APP_TIMEZONE = "Asia/Tokyo";

// フォーム用フォーマット
export const DATE_FORMAT_YMD = "YYYY-MM-DD";

// YYYY-MM-DD を東京時間で厳密パース
export const parseYmdStart = (dateStr) => {
  if (!dateStr) return null;

  const d = dayjs.tz(dateStr, DATE_FORMAT_YMD, APP_TIMEZONE);
  return d.isValid() ? d.startOf("day") : null;
};

// 東京時間の今日（00:00）
export const todayStart = () => dayjs().tz(APP_TIMEZONE).startOf("day");

// 東京時間の今日を YYYY-MM-DD 形式で返す
export const todayYmd = () => dayjs().tz(APP_TIMEZONE).format(DATE_FORMAT_YMD);
